import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectUI from '../../../widgets/form/InputSelectUI'
const ProcessingFeeModalUI = ({ context, successMsg, errorList, setErrorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick,
    //
    processingFeeFromLoan,onProcessingFeeFromLoanChange,processingFeeFromLoanError, booleanList
}) =>
    <ModalFormUI
        context={context}
        buttonLabel='Update'
        cancelLabel='Cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputSelectUI name='processingFeeFromLoan' value={processingFeeFromLoan} required={true}
         label='Processing Fee From Loan'optionList={booleanList} onChange={onProcessingFeeFromLoanChange}
          error={processingFeeFromLoanError}
        />
    </ModalFormUI>

export default ProcessingFeeModalUI
